import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ className }) => {
    const footerClassName = className
        ? `border-t border-earth-700 dark:border-earth-100/20 pt-5 scroll-mt-24 w-full max-w-7xl mx-auto pb-8`
        : 'border-t border-earth-700 dark:border-earth-100/20 pt-5 mt-20 scroll-mt-24 w-full max-w-7xl mx-auto pb-8';

    return (
        <footer className={footerClassName}>
            <div className="mx-auto flex flex-col gap-2 text-center sm:flex-row sm:items-center sm:justify-between sm:text-left px-4 sm:px-6 lg:px-8">
                <p className="text-sm text-earth-700 dark:text-earth-100/80">
                    © 2026 Portfolio. All rights reserved.
                </p>
                <div className="flex items-center justify-center gap-6 sm:justify-end">
                    <Link to="/terms" className="text-sm text-earth-700 hover:text-earth-900 dark:text-earth-100/80 dark:hover:text-earth-50 transition-colors duration-200">
                        Terms of Service
                    </Link>
                    <Link to="/privacy" className="text-sm text-earth-700 hover:text-earth-900 dark:text-earth-100/80 dark:hover:text-earth-50 transition-colors duration-200">
                        Privacy
                    </Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
